import ZAFClient from 'zendesk_app_framework_sdk'
const zafClient = ZAFClient.init()

export const resize = () => {
    zafClient.invoke('resize', { width: '100%', height: '400px' })
}

export const getTicket = () => {
    return zafClient.get('ticket').then((response) => {
        return { ticket: response.ticket }
    }, (response) => {
        return `Error from zafClient ticket status: ${response.status}`
    })
}


export const sendToInstance = (instanceName, message) => {
    return zafClient.get('instances').then((response) => {
        const instances = response.instances;
        // Find the instance ID of the ticket_sidebar
        for (const instanceKey in instances) {
            if (instances[instanceKey].location === instanceName) {
                // Send a message to the instance
                const theInstance = zafClient.instance(instanceKey);
                const result = theInstance.trigger('custom_event', { message: message });
            }
        }
    }, (response) => {
        return `Error from zafClient instances status: ${response.status}`
    })
}

export const onMessage = (callback) => {
    zafClient.on('custom_event', function (e) {
        return callback(e);
    });
}



export const getMetadata = () => {
    return zafClient.metadata().then(function (metadata) {
        return metadata
    });
}
export const getContext = () => {
    return zafClient.context().then(function (context) {
        return context
    });
}
export const getCurrentUser = () => {
    return zafClient.get('currentUser').then(function (currentUser) {
        return currentUser
    });
}

export const getChatId = () => {
    return zafClient.get('chat.id').then(function (response) {
        return response
    });
}
export const getChannel = () => {
    return zafClient.get('channel').then(function (response) {
        return response
    });
}
export const getChannelNameFromEditor = () => {
    return zafClient.get('ticket.editor.targetChannel.name').then(function (response) {
        return response
    });
}
// client.get('ticket.editor.targetChannel.name')

export const getCurrentAccount = () => {
    return zafClient.get('currentAccount').then(function (response) {
        return response
    });
}
export const getVisitor = () => {
    return zafClient.get('visitor').then(function (response) {
        return response
    });
}

export const getTicketRequester = () => {
    return zafClient.get('ticket.requester').then(function (response) {
        return response
    });
}
export const getTicketComment = () => {
    return zafClient.get('ticket.comment').then(function (response) {
        return response
    });
}
export const getTicketComments = () => {
    return zafClient.get('ticket.comments').then(function (response) {
        return response
    });
}
export const getTicketId = () => {
    return zafClient.get('ticket.id').then(function (response) {
        return response
    });
}
export const getTicketIsNew = () => {
    return zafClient.get('ticket.isNew').then(function (response) {
        return response
    });
}
export const getTicketBrand = () => {
    return zafClient.get('ticket.brand').then(function (response) {
        return response
    });
}
export const getTicketDetails = () => {
    return zafClient.get(['ticket.brand', 'ticket.comment', 'ticket.id', 'ticket.isNew']).then(function (response) {
        return response
    });
}
export const getTicketFields = () => {
    return zafClient.get('ticketFields').then(function (response) {
        return response
    });
}
export const getTicketField = (name) => {
    return zafClient.get('ticket.customField:' + name).then(function (response) {
        return response
    });
}

export const getTicketFieldsRequest = () => {
    var options = {
        type: "GET",
        timeout: 20000,
        url: "/api/v2/ticket_fields.json",
        httpCompleteResponse: true,
        accepts: {
            text: 'application/json'
        },
        autoRetry: true,
        cache: false,
        contentType: "application/json"
    }
    return zafClient.request(options).then(function (response) {
        return response
    });
}
export const getTicketFieldRequest = (name) => {
    var options = {
        type: "GET",
        timeout: 20000,
        url: "/api/v2/ticket_fields/" + name + ".json",
        httpCompleteResponse: true,
        accepts: {
            text: 'application/json'
        },
        autoRetry: true,
        cache: false,
        contentType: "application/json"
    }
    return zafClient.request(options).then(function (response) {
        return response
    });
}

export const getTicketConversation = () => {
    return zafClient.get('ticket.conversation').then(function (response) {
        return response
    });
}




export const closePopup = () => {
    return zafClient.invoke('app.close');
}
export const hideField = (identifier) => {
    return zafClient.invoke('ticketFields:' + identifier + '.hide');
}

export const setTag = (string) => {
    return zafClient.invoke('ticket.tags.add', string).then(function (response) {
        return response
    });
}




export const insertCommentHtml = (html) => {
    return zafClient.invoke('comment.appendHtml', html);
}
export const insertCommentMarkdown = (markdown) => {
    return zafClient.invoke('comment.appendMarkdown', markdown);
}





// export const sendButtonTemplate = (template) => {
//     return zafClient.invoke('sendButtonTemplate', template);
// }
export const postToChatTextArea = (string) => {
    return zafClient.invoke('chat.postToChatTextArea', string);
}
export const sendChat = (string) => {
    return zafClient.invoke('chat.sendChat', string);
}
export const insertCommentText = (text) => {
    return zafClient.invoke('comment.appendText', text);
}
export const editorInsertHtml = (html) => {
    return zafClient.invoke('ticket.editor.insert', html);
}
export const editorInsertLink = () => {
    return zafClient.invoke('ticket.editor.hyperlink');
}
export const editorInsertImage = (image_url) => {
    return zafClient.invoke('ticket.editor.inlineImage', image_url);
}

export const sendMessage = (channel, message) => {
    return zafClient.invoke('ticket.sendMessage', { channel: channel, message: message });
    // Example: client.invoke('ticket.sendMessage', { channel: 'chat', message: 'Hello, world.' })
    // Example: client.invoke('ticket.sendMessage', { channel: 'messaging', message: 'Hello, world.' })
}

export const setTicketCustomField = (name, value) => {
    return zafClient.set('ticket.customField:' + name, value);
}




export const setKey = (key, val) => {
    return zafClient.metadata().then(function (metadata) {
        //return localStorage.setItem(metadata.installationId + ":" + key, val);
        if (storageAvailable('localStorage')) {
            return localStorage.setItem(metadata.installationId + ":" + key, val);
        } else if (storageAvailable('sessionStorage')) {
            return sessionStorage.setItem(metadata.installationId + ":" + key, val);
        } else {
            return null
        }
    });
}

export const deleteKey = (key) => {
    return zafClient.metadata().then(function (metadata) {
        if (storageAvailable('localStorage')) {
            localStorage.removeItem(metadata.installationId + ":" + key);
        } else if (storageAvailable('sessionStorage')) {
            sessionStorage.removeItem(metadata.installationId + ":" + key);
        } else {
            return null;
        }
    });
}

export const getKey = (key) => {
    return zafClient.metadata().then(function (metadata) {
        if (storageAvailable('localStorage')) {
            return localStorage.getItem(metadata.installationId + ":" + key);
        } else if (storageAvailable('sessionStorage')) {
            return sessionStorage.getItem(metadata.installationId + ":" + key);
        } else {
            return null
        }
    });
}

function storageAvailable(type) {
    try {
        var storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return false;
    }
}

export const onChatStart = (callback) => {
    zafClient.on('channel.chat.start', function (evt) {
        return callback(evt);
    });
}
export const onChatEnd = (callback) => {
    zafClient.on('channel.chat.end', function (evt) {
        return callback(evt);
    });
}



export const onAppExpanded = (callback) => {
    zafClient.on('app.expanded', function () {
        return callback;
    });
}
export const onAppActivated = (callback) => {
    zafClient.on('app.activated', function () {
        return callback;
    });
}
export const onPaneActivated = (callback) => {
    zafClient.on('pane.activated', function () {
        return callback;
    });
}
export const onTicketChanged = (callback) => {
    zafClient.on('*.changed', function (e) {
        return callback(e);
    });
}
export const onTicketSubmitDone = (callback) => {
    zafClient.on('ticket.submit.done', function (e) {
        return zafClient.on('ticket.save', callback);
        //return callback(e);
    });
}
export const onTicketSave = (callback) => {
    zafClient.on('ticket.save', callback);
}
export const onTicketSubmitStart = (callback) => {
    zafClient.on('ticket.submit.start', function (e) {
        return callback(e);
    });
}






// appId: "79919bd6-c947-426c-81e7-3c9bdcbe57da"
// installationId: "b3d279a3-7964-406e-802d-edbe2795db26"


// export const setParam = () => {
//   return zafClient.set({'metadata.settings': {'integration':8,'team_slug':'yoyo'}}).then((data) => {
//     console.log(data);
//   })
// }
// client.set({ 'ticket.subject': 'Printer Overheating Incident', 'ticket.type': 'incident' }).then(function(data) {
//   console.log(data); // { 'ticket.subject': 'Printer Overheating Incident', 'ticket.type': 'incident' }
// });

// client.invoke('resize', { width: '100%', height: '200px' });
//
// client.metadata().then(function(metadata) {
//   console.log(metadata.settings);
//   if (!metadata.settings.team_slug) {
//     console.log("pas de team slug")
//   }
//   if (!metadata.settings.integration) {
//     console.log("pas d'integration")
//   }
// });



//console.log("ZAF Loaded")
